export enum GenericEvents {
	CLICK_BREADCRUMB = 'click_breadcrumb',
	PDP_ACTION = 'pdp_action',
	CLICK_SIZE = 'click_size',
	CLICK_SIZE_GUIDE = 'click_size_guide',
	SHOW_DISCLAIMER_SIZE = 'show_disclaimer_size',
	VIDEO_VIEW = 'video_view',
	VIDEO_ERROR = 'video_error',
	VIDEO_AUTO_PLAY = 'video_auto_play',
	VIDEO_AUTO_PAUSE = 'video_auto_pause',
	VIDEO_PLAY_CLICK = 'video_play_click',
	VIDEO_PAUSE_CLICK = 'video_pause_click',
	VIDEO_ENDED = 'video_ended',
}
